import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  perMonth: {
    defaultMessage: '{price} per mo.',
    description: 'A subscription plans cost per month',
    id: '04iaVj',
  },
  perYear: {
    defaultMessage: '{price} per year',
    description: 'A subscription plans cost per year',
    id: '1gmvhv',
  },
});
